import { Box, Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { FC, useCallback, useEffect, useState } from "react";
import {
  Abordagem,
  createAbordagem,
  deleteAbordagem,
  getAbordagens,
  updateAbordagem,
} from "src/apis/eezyfamily";
import PageContainer from "src/pages/components/PageContainer";
import { isUserAdministrator } from "src/utils/auth";
import AbordagensTable from "./components/AbordagensTable";
import AbordagemModal from "./components/AbordagemModal";

const EFAbordagensPage: FC = (): JSX.Element => {
  const [entries, setEntries] = useState<Abordagem[]>([]);
  const [error, setError] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [editTarget, setEditTarget] = useState<Abordagem | null>(null);

  const load = useCallback(async () => {
    try {
      const data = await getAbordagens();
      setEntries(data);
      setError("");
    } catch (err: any) {
      setError(err?.message ?? "Erro ao carregar abordagens.");
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const handleEdit = (item: Abordagem) => {
    setEditTarget(item);
    setModalOpen(true);
  };

  const handleAdd = () => {
    setEditTarget(null);
    setModalOpen(true);
  };

  const handleDelete = async (id: number) => {
    if (
      !window.confirm(
        "Tem certeza que deseja excluir esta abordagem? Esta ação não pode ser desfeita."
      )
    )
      return;
    try {
      await deleteAbordagem(id);
      setEntries((prev) => prev.filter((e) => e.id !== id));
    } catch (err: any) {
      setError(err?.message ?? "Erro ao excluir.");
    }
  };

  const handleSaved = () => {
    setModalOpen(false);
    load();
  };

  return (
    <PageContainer title="Abordagens Terapêuticas" error={error} guard={isUserAdministrator}>
      <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 1 }}>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={handleAdd}
        >
          Adicionar Abordagem
        </Button>
      </Box>

      <AbordagensTable
        abordagens={entries}
        onEdit={handleEdit}
        onDelete={handleDelete}
      />

      <AbordagemModal
        open={modalOpen}
        editTarget={editTarget}
        onClose={() => setModalOpen(false)}
        onSaved={handleSaved}
        onCreate={createAbordagem}
        onUpdate={updateAbordagem}
      />
    </PageContainer>
  );
};

export default EFAbordagensPage;
